export default "static/dist/img/sharp-clear-24px.svg?1e2c35475bcd5444526de3eb1f0134a2";